import React from 'react';
import { useWebSocket } from '../context/WebSocketContext';
import './NotificationToast.css';

const NotificationToast = () => {
  const { notifications, clearNotification } = useWebSocket();

  if (notifications.length === 0) return null;

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`notification-toast ${notification.type}`}
          onClick={() => clearNotification(notification.id)}
        >
          <div className="notification-content">
            <span className="notification-message">{notification.message}</span>
            <button className="notification-close" onClick={(e) => {
              e.stopPropagation();
              clearNotification(notification.id);
            }}>
              ×
            </button>
          </div>
          <div className="notification-progress"></div>
        </div>
      ))}
    </div>
  );
};

export default NotificationToast;
